var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0A7.749 7.749 0 000 7.75a7.749 7.749 0 007.75 7.75 7.749 7.749 0 007.75-7.75A7.749 7.749 0 007.75 0zm6.75 7.75a6.75 6.75 0 01-6.75 6.75A6.75 6.75 0 011 7.75 6.75 6.75 0 017.75 1a6.75 6.75 0 016.75 6.75zm-4.653 2.76L7.309 8.665a.377.377 0 01-.153-.303V3.375c0-.206.169-.375.375-.375h.438c.206 0 .375.169.375.375v4.572l2.203 1.603a.375.375 0 01.081.525l-.256.353a.378.378 0 01-.525.081z",
    fill: "var(--color-primary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.84553c21511a1b59a58877c98fe98b32.svg";
export { ForwardRef as ReactComponent };